<template>
    <b-modal id="add-badge-custom-icon-modal" title="Add badge custom icon" body-bg-variant="white" body-class="bg-white"
             v-model="showAddBadgeCustomIcon" >
        <div class="container-grid pl-3">
            <div class="col-grid" v-for="column in columns">
                <div class="item-container" v-for="badgeIcon in column">
                    <input type="radio" id="one" :value="badgeIcon" v-model="picked">
                    <img style="max-width:100px" :src="badgeIcon.downloadUrl"/>
                </div>
            </div>
        </div>
        <template v-slot:modal-footer>
            <div class="ml-auto">
                <div class="popover-danger"
                           triggers="click"
                           v-show="showDeletePopup && picked != null"
                           placement="top">
                    <div slot="title">
                        <div class="px-5">Warning: Deleting this file will cause the badges that use it not to work anymore. Are you sure you want to remove this badge file?</div>
                    </div>
                    <div class="px-5 d-flex justify-content-center">
                        <b-button-toolbar>
                            <b-button variant="success" size="xs"
                                      @click="deleteItem(picked)">
                                Yes
                            </b-button>
                            <b-button variant="danger" size="xs"
                                      @click="showDeletePopup = false">
                                No
                            </b-button>
                        </b-button-toolbar>
                    </div>
                </div>
            </div>
            <b-button variant="danger" @click="tryDeleteItem(picked)">Delete</b-button>
            <b-button variant="primary"  @click="()=>{pickIcon(picked);showAddBadgeCustomIcon = false}"
                      v-bind:disabled="picked == null">Save</b-button>
            <b-button variant="secondary" @click="showAddBadgeCustomIcon = false">Close</b-button>
        </template>
    </b-modal>
</template>

<script>
  import {mapActions, mapState} from "vuex";
  import {firestore, } from "../../main";
  import Vue from "vue";
  import vSelect from "vue-select";

  export default {
    name: "AddBadgeCustomIcon",
    components: {vSelect},
    data(){
      return {
        showAddBadgeCustomIcon: false,
        popover: false,
        error: null,
        picked: null,
          showDeletePopup: false,
        cols: 2,
          selectedCountryId: null
      }
    },
    computed: {
      ...mapState("badges", ["availableBadgeIcons","customBadgesIcons"]),
        ...mapState("auth", ["currentUser"]),
      columns: function() {
        let columns = []
        if(this.customBadgesIcons) {
            let mid = Math.ceil(this.customBadgesIcons.length / this.cols)
            for (let col = 0; col < this.cols; col++) {
                columns.push(this.customBadgesIcons.slice(col * mid, col * mid + mid))
            }
        }
        return columns
      }
    },
    methods: {
      ...mapActions("badges", ["getAvailableBadgeIcons", "pickIcon","getAvailableCustomBadgeIcons","deleteBadgeFile"]),
        ...mapActions("auth", ["fetchCurrentUser"]),
        async tryDeleteItem(item) {
          // debugger;
          this.showDeletePopup = true;
        },
        async deleteItem(item) {
            this.showDeletePopup = false;
            if(this.selectedCountryId == null) {
                return;
            }
            let fileId = item.id;
            if(fileId == null || fileId == undefined) {
                return;
            }
            let payload = {
                tenantId: this.selectedCountryId,
                fileId: fileId

            }
            await this.deleteBadgeFile(payload);
            await this.getAvailableCustomBadgeIcons(this.selectedCountryId);
        },
    },
    async mounted() {
        if (this.currentUser == undefined || this.currentUser.id == null) {
            await this.fetchCurrentUser();
        }
        this.selectedCountryId = this.currentUser.selectedCountryId;
        await this.getAvailableCustomBadgeIcons(this.selectedCountryId);
    }
  }
</script>

<style scoped>
    .container-grid {
        display: flex;
    }
    .col-grid {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
    }
</style>
